import React, { ChangeEvent, useId } from 'react';

export interface RoundedCheckboxProps {
	id?: string;
	name?: string;
	value?: string;
	label: React.ReactNode;
	checked?: boolean;
	defaultChecked?: boolean;
	onChange?: (event: ChangeEvent<HTMLInputElement>) => void;
	disabled?: boolean;
	className?: string;
	ariaLabel?: string;
}

export interface RoundedCheckboxGroupProps {
	label?: string;
	required?: boolean;
	children: React.ReactNode;
	className?: string;
}

export const RoundedCheckbox: React.FC<RoundedCheckboxProps> = ({
	id,
	name,
	value,
	label,
	checked,
	defaultChecked,
	onChange,
	disabled,
	className,
	ariaLabel,
}) => {
	const generatedId = useId();
	const inputId = id ?? `rounded-checkbox-${generatedId}`;

	const rootClassName = ['custom-checkbox-round', className].filter(Boolean).join(' ');

	return (
		<div className={rootClassName}>
			<input
				type="checkbox"
				id={inputId}
				name={name}
				value={value}
				checked={checked}
				defaultChecked={defaultChecked}
				onChange={onChange}
				disabled={disabled}
				aria-label={ariaLabel}
			/>
			<label htmlFor={inputId}>{label}</label>
		</div>
	);
};

export const RoundedCheckboxGroup: React.FC<RoundedCheckboxGroupProps> = ({
	label,
	required = false,
	children,
	className,
}) => {
	const wrapperClassName = ['rouded-checkbox-wrapper', className].filter(Boolean).join(' ');

	return (
		<div className={wrapperClassName}>
			{label && <span className={`chips-radio-label${required ? ' required' : ''}`}>{label}</span>}
			<div className="rouded-checkbox-option">{children}</div>
		</div>
	);
};

export default RoundedCheckbox;
